import React from "react"
import SeoLandingPage from "./SeoLandingPage"
import { SEO_KEYWORDS_EXTRA } from "../../seo/extraKeywords"

export default function BedBpedKashmirGuidance() {
  return (
    <SeoLandingPage
      path="/kashmir-bed-bped-admission-odisha"
      title="Kashmir B.Ed / BP.Ed Admission Guidance for Odisha Students | Devbhumi"
      description="Odisha students ke liye Kashmir B.Ed/BP.Ed admission counselling + coaching. Eligibility, documents, admission processing, books and online classes with Bhadrak office support."
      keywords={`Kashmir University B.Ed Odisha, Kashmir B.Ed admission Odisha students, Kashmir BP.Ed guidance Odisha, B.Ed from Kashmir for Odisha, ${SEO_KEYWORDS_EXTRA}`}
      h1="Kashmir B.Ed / BP.Ed Admission Guidance (Odisha Students)"
      intro="If you are searching Kashmir B.Ed/BP.Ed admission from Odisha, we provide counselling, eligibility guidance, admission processing support, study materials and online coaching. You can also visit our Bhadrak office for offline help."
      bullets={[
        "Counselling for Kashmir B.Ed/BP.Ed admissions",
        "Eligibility + document checklist support",
        "Form fill-up and admission processing guidance",
        "Online coaching/classes + study material guidance",
        "Offline support and book distribution via Bhadrak office",
        "Support for students across Odisha (Bhadrak, Balasore, Baripada, Mayurbhanj)",
      ]}
      areaServed={[
        { "@type": "State", name: "Odisha" },
        { "@type": "AdministrativeArea", name: "Kashmir" },
        { "@type": "City", name: "Bhadrak" },
      ]}
      faqs={[
        {
          q: "Do you help Odisha students for Kashmir admissions?",
          a: "Yes. We guide Odisha students through counselling, documents and admission processing, plus coaching support.",
        },
        {
          q: "Is online coaching available?",
          a: "Yes. Online classes/coaching are available along with admission guidance.",
        },
        {
          q: "Can I visit the office for help?",
          a: "Yes. You can visit our Bhadrak office for counselling, document support and books.",
        },
      ]}
    />
  )
}

